module.exports = __webpack_public_path__ + "img/map.86905302.png";